/**
 * SSOT browser download utility.
 * Triggers a file download via invisible anchor + blob URL.
 * Automatically revokes the blob URL after 60s.
 */
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    console.warn('triggerBrowserDownload is only supported in browser environments');
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
